import React, { Component } from 'react'
import styled from 'styled-components'

import { Text } from 'ui/styles/utils'
import FadeEntry from 'ui/components/generic/FadeEntry'
import ScrollIndicatorComponent from 'ui/components/generic/ScrollIndicator'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  color: #fff;
`

const ScrollIndicator = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  margin-left: -10px;
`

const Header = Text.extend`
  position: relative;
  margin-bottom: 50px;

  &:after {
    display: block;
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-top: 50px;
    margin-left: -25px;
    height: 2px;
    width: 50px;

    background-color: #fff;
  }
`.withComponent('h1')

const SubTitle = Text.extend`
  margin: 50px 10vw 0;
  font-family: ${props => props.theme.bodyFont};
  text-align: center;
`.withComponent('h2')

class index extends Component {
  render() {
    const {
      post: { title },
      subTitle
    } = this.props

    return (
      <Wrapper>
        <Header size="xl">{title}</Header>
        <FadeEntry direction="left" delay={600} scroll={false} debug>
          <SubTitle size="md">{subTitle}</SubTitle>
        </FadeEntry>
        <ScrollIndicator>
          <FadeEntry delay={1000} scroll={false}>
            <ScrollIndicatorComponent />
          </FadeEntry>
        </ScrollIndicator>
      </Wrapper>
    )
  }
}

export default index



// WEBPACK FOOTER //
// ./src/ui/components/modules/PageHeader/index.js